import { errorLogger } from '@ajaibid/utils';
import fetcher from '@/helpers/fetcher';

function getUrl() {
  return 'v3/users/me/pin/get-pin-data';
}

/**
 * @param {string} url
 */
function callbackFetch(url) {
  return async () => {
    try {
      // Since this API is called before pin, need to use pin_token instead of access_token in API calls
      const meta = { isUsingPinToken: true };

      /** @type {import('./typedefs').Response} */
      const res = await fetcher.get(url, { meta });
      return res.data;
    } catch (err) {
      errorLogger('ERROR_API', err.message);
      throw err;
    }
  };
}

export default function fetch() {
  const url = getUrl();

  return {
    cb: callbackFetch(url),
    key: [url],
  };
}
